/**
 * @generated SignedSource<<c3536e1c50f5229f52bdaa8f0f502571>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TrancheSelection_component$data = {
  readonly tranches: {
    readonly trancheSelectBox: {
      readonly options: ReadonlyArray<{
        readonly key: string | null | undefined;
        readonly label: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"LabeledSelectBox_labeledSelectBox">;
  } | null | undefined;
  readonly " $fragmentType": "TrancheSelection_component";
};
export type TrancheSelection_component$key = {
  readonly " $data"?: TrancheSelection_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"TrancheSelection_component">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TrancheSelection_component",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LabeledSelectBox",
      "kind": "LinkedField",
      "name": "tranches",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LabeledSelectBox_labeledSelectBox"
        },
        {
          "alias": "trancheSelectBox",
          "args": null,
          "concreteType": "SelectBox",
          "kind": "LinkedField",
          "name": "selectbox",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SelectBoxItem",
              "kind": "LinkedField",
              "name": "options",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "key",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "label",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TrancheSelection",
  "abstractKey": null
};

(node as any).hash = "79ad7c4f1fd8786463ca9d7c6e2c15f0";

export default node;
